export default "__VITE_ASSET__fc4af02e__"